export const apiKeyShan = "AIzaSyCrJJxxzVwMQdIpAKxVz6_9xSJeVtJJGzQ" //LI Google API key
//export const apiKeyShan = "AIzaSyDLO_MDBJAEmFmorbbVhR5akIJT1DJkbZw"

export const mapOptions = {
  types: ["establishment", "geocode"],
  componentRestrictions: { country: "au" }
}
